module.exports = __webpack_public_path__ + "c4aa36091cfa12b43d001aa4080652e5.MP3";